import { Cart, CartItemInterface, Maybe } from '@pylot-data/pylotschema'

const totalQty = (items?: Maybe<Maybe<CartItemInterface>[]>): number => {
    if (!items || items.length === 0) {
        return 0
    }
    let qty = 0
    items.forEach((item) => (qty += item?.quantity ?? 1))
    return qty
}

export const getQtyChange = (newState?: Cart, oldState?: Cart): number => {
    if (!oldState || !newState) {
        return 0
    }
    return totalQty(newState['items']) - totalQty(oldState['items'])
}

export const identifyPDPCartOperationName = (
    newState?: Cart,
    oldState?: Cart,
    gtmLocation?: string
): string => {
    // Loading cart on the first time/login/logout
    const qtyChange = getQtyChange(newState, oldState)

    if (qtyChange > 0) {
        return 'ADD_TO_CART_PDP'
    }

    return ''
}
